import MainLayout from '../components/main-layout'
import channel from './channel'
import doc from './doc'

export default [
  {
    path: '/admin',
    component: MainLayout,
    // 标记为侧边栏菜单
    isAside: true,
    children: [
      {
        path: '',
        component: () => import('../views/dashboard'),
        label: 'Home',
        icon: 'fa fa-home'
      },
      channel,
      doc
      // {
      //   link: 'https://film.qq.com/',
      //   component: () => import('../views/page1'),
      //   label: '腾讯视频',
      //   icon: 'fa fa-link'
      // },
      // {
      //   path: 'page1',
      //   component: () => import('../views/page1'),
      //   label: '页面1',
      //   icon: 'fa fa-file-text'
      // },
      // {
      //   path: 'page2',
      //   component: () => import('../views/page2'),
      //   label: '页面2',
      //   icon: 'fa fa-file-text'
      // },
      // {
      //   path: 'page3',
      //   component: () => import('../views/page3'),
      //   label: '页面3',
      //   show: true,
      //   icon: 'fa fa-file-text'
      // },
      // {
      //   path: '/submenu',
      //   component: {
      //     render () {
      //       return <div><router-view /></div>
      //     }
      //   },
      //   label: '二级页面',
      //   icon: 'fa fa-file-text',
      //   children: [
      //     {
      //       isGroup: true,
      //       label: 'group',
      //       children: [
      //         {
      //           path: 'group11',
      //           label: '分组0-1',
      //           component: {
      //             render () {
      //               return <div>分组0-1</div>
      //             }
      //           }
      //         }
      //       ]
      //     },
      //     {
      //       path: 'test1',
      //       component: {
      //         render () {
      //           return <div>test1</div>
      //         }
      //       },
      //       label: '二级页面1'
      //     },
      //     {
      //       path: 'test2',
      //       component: {
      //         render () {
      //           return <div>test2</div>
      //         }
      //       },
      //       label: '二级页面2'
      //     },
      //     {
      //       link: 'https://v.qq.com',
      //       label: '连接'
      //     }
      //   ]
      // },
      // {
      //   path: 'user',
      //   component: () => import('../views/user'),
      //   label: '用户中心',
      //   icon: 'el-icon-service'
      // },
      // {
      //   path: 'test',
      //   // 菜单渲染成组
      //   isGroup: true,
      //   label: '系统设置',
      //   component: () => import('../views/user'),
      //   children: [
      //     {
      //       path: 'group1',
      //       label: '设置',
      //       icon: 'fa fa-cog',
      //       component: () => import('../views/user')
      //     },
      //     {
      //       path: 'https://film.qq.com/',
      //       link: 'https://film.qq.com/',
      //       component: () => import('../views/page1'),
      //       label: '关于',
      //       icon: 'fa fa-link'
      //     }
      //   ]
      // }
    ]
  }
]
